import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function MarqueeRender({ node }) {
  const content = node.content || {};
  
  const text = content.text || 'O2 Mobile 5G +++ Gigabit Speed +++ Kostenloses Roaming +++ Grow Feature +++ ';
  const duration = parseInt(content.duration, 10) || 15; // sekunden
  const reverse = content.reverse === 'true';
  const color = content.color || 'var(--tef-primary, #00A9E0)';
  const fontSize = content.fontSize || '48px';
  const outline = content.outline === 'true';

  // Keyframes werden global in App.css / Designer.css verwaltet oder hier über Inline-Styling-Workaround simuliert
  // Ein sicherer Weg ohne CSS-Datei-Injection in React ist eine Animation mit CSS Variables oder Standard-Keyframes, 
  // die bereits in index.css liegen könnten. Wir definieren eine Inline-<style> injection für Marquee.
  const animationName = reverse ? 'marquee-reverse' : 'marquee';

  return (
    <div style={{
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      position: 'relative',
      padding: '20px 0',
      background: content.bgColor || 'transparent'
    }}>
      <style>
        {`
          @keyframes marquee {
            0%   { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
          @keyframes marquee-reverse {
            0%   { transform: translateX(-50%); }
            100% { transform: translateX(0%); }
          }
        `}
      </style>
      
      <div style={{
        display: 'inline-block',
        whiteSpace: 'nowrap',
        animation: `${animationName} ${duration}s linear infinite`,
        // Wir verdoppeln den Text visuell, damit es einen nahtlosen Loop gibt
        fontSize: fontSize,
        fontWeight: '900',
        textTransform: 'uppercase',
        color: outline ? 'transparent' : color,
        WebkitTextStroke: outline ? `1px ${color}` : 'none',
        letterSpacing: '2px'
      }}>
        <span style={{ paddingRight: '50px' }}>{text}</span>
        <span style={{ paddingRight: '50px' }}>{text}</span>
      </div>
    </div>
  );
}

registry.register('Marquee', {
  label: 'Lauftext (Marquee)',
  icon: '🔤', 
  category: 'advanced', // oder premium
  component: MarqueeRender,
  
  defaultProps: {
    content: {
      text: 'O2 Mobile 5G +++ Gigabit Speed +++ Kostenloses Roaming +++ Grow Feature +++ ',
      duration: '15',
      reverse: 'false',
      color: '#00A9E0',
      bgColor: 'transparent',
      fontSize: '48px',
      outline: 'true'
    },
    style: {
      desktop: {
        width: '100%',
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Text & Laufschrift',
          fields: [
            { name: 'content.text', label: 'Lauftext', type: 'text' },
            { name: 'content.duration', label: 'Geschwindigkeit (Sekunden für Loop)', type: 'text' },
            { name: 'content.reverse', label: 'Rückwärts (Rechts-nach-Links)?', type: 'select', options: ['false', 'true'] }
          ]
        },
        {
          title: 'Design',
          fields: [
            { name: 'content.color', label: 'Textfarbe', type: 'color' },
            { name: 'content.bgColor', label: 'Hintergrundfarbe (Box)', type: 'color' },
            { name: 'content.fontSize', label: 'Schriftgröße (z.B. 48px)', type: 'text' },
            { name: 'content.outline', label: 'Als Outline-Text (Transparent + Rand)?', type: 'select', options: ['true', 'false'] }
          ]
        }
      ]
    }
  ]
});
